type AllowedPeriod = 'sevenDays' | 'oneMonth' | 'threeMonths' | 'sixMonths';
type Period = { value: AllowedPeriod; label: string };

export const PERIODS: Period[] = [
  { value: 'sevenDays', label: 'Last 7 Days' },
  { value: 'oneMonth', label: 'Last Month' },
  {
    value: 'threeMonths',
    label: 'Last 3 Months',
  },
  { value: 'sixMonths', label: 'Last 6 Months' },
];
